<router-outlet></router-outlet>
<app-loader></app-loader>
 <app-network-modal></app-network-modal>
<p-toast [breakpoints]="{ '420px': { width: '100%', right: '0', left: '0' } }"></p-toast>